export default __webpack_public_path__ + "static/media/trip_deferred.d38cbd11.svg";